import React from "react";
import { utils } from "../../Helpers/utils";
import { TableCell, TableRow } from "@mui/material";
export default function DashboardItem(props) {
  return (
    <TableRow
      hover
      sx={{
        "& td": {
          py: 1.5,
          px: 2.5,
          borderBottom: "1px solid #F3F4F6",
          fontSize: "14px",
        },
        "&:hover": {
          backgroundColor: "#FAFAFA !important",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "rgba(248, 250, 252, 0.5)",
        },
        cursor: "pointer",
      }}
    >
      <TableCell
        sx={{
          color: "#1F2937",
          fontWeight: 500,
          fontSize: "15px",
          textAlign: "left",
          width: { xs: "120px", lg: "25%" },
          minWidth: "120px",
          maxWidth: "200px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {props.title}
      </TableCell>
      <TableCell
        sx={{
          textAlign: "center",
          color: "#64748B",
          fontSize: "14px",
          fontWeight: 400,
          width: { xs: "100px", lg: "20%" },
          minWidth: "100px",
        }}
      >
        {props.start_date}
      </TableCell>
      <TableCell
        sx={{
          textAlign: "left",
          color: "#475569",
          fontSize: "14px",
          fontWeight: 400,
          width: { xs: "180px", lg: "35%" },
          minWidth: "180px",
          maxWidth: "300px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {props.description &&
          utils.draftJsFormatingForDetails({
            data: props.description,
            view: "column",
          })}
      </TableCell>
      <TableCell
        sx={{
          color: "#059669",
          fontSize: "14px",
          fontWeight: 600,
          textAlign: "right",
          width: { xs: "100px", lg: "20%" },
          minWidth: "100px",
        }}
      >
        {props.budget}
      </TableCell>
    </TableRow>
  );
}
